import { CloudOff } from 'lucide-react';
import { Button } from '@/components/ui/Button';

type Props = {
  /** Läuft gerade ein Versuch? Dann sagt der Knopf das statt zu locken. */
  laeuft: boolean;
  /** Noch einmal bei auth/me nachfragen. */
  onErneut: () => void;
};

/**
 * Die Ansicht für „der Server hat auf die Anmeldefrage nicht brauchbar
 * geantwortet" — Befund A-06.
 *
 * Vorher stand hier ein Drehrädchen auf weißer Fläche, und dahinter
 * feuerte das Gerät mehrere hundert Anfragen je Sekunde gegen einen
 * Server, der ohnehin gerade nicht konnte. Sichtbar war davon nichts.
 *
 * Zwei Dinge macht diese Ansicht deshalb anders: Sie sagt, was los ist,
 * und sie gibt einen Knopf. Das automatische Nachfragen läuft daneben
 * weiter — ein Tablet an der Wand soll ohne Fingertipp zurückkommen,
 * sobald der Server wieder antwortet —, aber im Ruhetakt und nicht im
 * Dauerfeuer.
 */
export function AuthStoerung({ laeuft, onErneut }: Props) {
  return (
    <div
      role="alert"
      className="flex min-h-screen flex-col items-center justify-center gap-4 bg-cream p-6 text-center"
    >
      <CloudOff className="h-10 w-10 text-coral" aria-hidden />
      <h1 className="font-serif text-xl text-ink">Keine Verbindung zum Server</h1>
      <p className="max-w-md text-sm text-ink-soft">
        Die Anmeldung lässt sich gerade nicht prüfen. Das liegt meist am WLAN oder
        daran, dass der Server kurz nicht erreichbar ist. Es geht nichts verloren —
        sobald er wieder antwortet, geht es von selbst weiter.
      </p>
      <Button onClick={onErneut} disabled={laeuft}>
        {laeuft ? 'Wird versucht …' : 'Erneut versuchen'}
      </Button>
      <p className="text-xs text-ink-faint">Es wird auch von selbst weiter versucht.</p>
    </div>
  );
}
